module.exports = __webpack_public_path__ + "explore/images/eoy/beekeeper-2x.9414d3f1635152bee2fcf9cf49a5bed0.png";